export default __webpack_public_path__ + "images/c7602d206536969f8b823b13075d72e6-charity_and_causes.jpg";